/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ConvexSiloWrapper,
  ConvexSiloWrapperInterface,
} from "../ConvexSiloWrapper";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository0612Like",
        name: "_siloRepository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newVault",
        type: "address",
      },
    ],
    name: "CollateralVaultUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "_wrapped",
        type: "bool",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_hook",
        type: "address",
      },
    ],
    name: "HookSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_rewardToken",
        type: "address",
      },
    ],
    name: "RewardInvalidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Shutdown",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_userA",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_userB",
        type: "address",
      },
    ],
    name: "UserCheckpoint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "_unwrapped",
        type: "bool",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "ERROR_COLLATERAL_VAULT_ZERO",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ERROR_INVALID_SILO_REPOSITORY",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ERROR_SILO_WRAPPER_ALREADY_INIT",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SILO_REPOSITORY",
    outputs: [
      {
        internalType: "contract ISiloRepository0612Like",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SILO_REPOSITORY_PING_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "addRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "addTokenReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "checkpointPair",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "checkpointSingle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "collateralVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexBooster",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexPoolId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "convexToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "crv",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "curveToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cvx",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ConvexStakingWrapper.EarnedData[]",
        name: "claimable",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earnedView",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ConvexStakingWrapper.EarnedData[]",
        name: "claimable",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_forwardTo",
        type: "address",
      },
    ],
    name: "getReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolId",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolId",
        type: "uint256",
      },
    ],
    name: "initializeSiloWrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "invalidateReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isShutdown",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isSiloOrRouter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isSiloWrapperInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardHook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "address",
        name: "reward_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "reward_pool",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "reward_integral",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reward_remaining",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "setApprovals",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_hook",
        type: "address",
      },
    ],
    name: "setHook",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shutdown",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "syncSilo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "totalBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "underlyingToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "user_checkpoint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawAndUnwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60a06040523480156200001157600080fd5b5060405162004d9d38038062004d9d833981016040819052620000349162000316565b604080518082018252601181527029ba30b5b2b221b7b73b32bc2a37b5b2b760791b6020808301918252835180850190945260068452650e6e8d686ecf60d31b9084015281519192916200008b9160039162000249565b508051620000a190600490602084019062000249565b505060058054601260ff19909116179055506001600655620000f0817fe99ed41de618732efbc0d0095584567f6718769787fe3fbb41fd1632fd5481c262000161602090811b620024fc17901c565b6200014b57604080518082018252601c81527f496e76616c696453696c6f5265706f7369746f727941646472657373000000006020820152905162461bcd60e51b81526200014291906004016200035d565b60405180910390fd5b60601b6001600160601b031916608052620003c5565b60408051600481526024810182526020810180516001600160e01b03166001600160e01b03198516179052905160009182916060916001600160a01b03871691620001ad91906200033f565b600060405180830381855afa9150503d8060008114620001ea576040519150601f19603f3d011682016040523d82523d6000602084013e620001ef565b606091505b50915091508115806200020457508051602014155b15620002165760009250505062000243565b6000818060200190518101906200022e9190620002e5565b6001600160e01b031986811691161493505050505b92915050565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f106200028c57805160ff1916838001178555620002bc565b82800160010185558215620002bc579182015b82811115620002bc5782518255916020019190600101906200029f565b50620002ca929150620002ce565b5090565b5b80821115620002ca5760008155600101620002cf565b600060208284031215620002f7578081fd5b81516001600160e01b0319811681146200030f578182fd5b9392505050565b60006020828403121562000328578081fd5b81516001600160a01b03811681146200030f578182fd5b600082516200035381846020870162000392565b9190910192915050565b60006020825282518060208401526200037e81604085016020870162000392565b601f01601f19169190910160400192915050565b60005b83811015620003af57818101518382015260200162000395565b83811115620003bf576000848401525b50505050565b60805160601c6149ab620003f26000398061145a5280611571528061185e5280611f0452506149ab6000f3fe608060405234801561001057600080fd5b50600436106103825760003560e01c80637acb7757116101de578063b277e8f01161010f578063e529ee95116100ad578063f8112eed1161007c578063f8112eed146106b8578063fc0e74d1146106cb578063fe4b84df146106d3578063ff833485146106e657610382565b8063e529ee9514610672578063e89133b21461067a578063f2fde38b14610682578063f301af421461069557610382565b8063c00007b0116100e9578063c00007b01461063c578063cc7d510e1461064f578063dcb4cd6314610657578063dd62ed3e1461065f57610382565b8063b277e8f014610619578063b95c57461461062c578063bf86d6901461063457610382565b8063923c1d611161017c578063a457c2d711610156578063a457c2d7146105e3578063a7e8489d146105f6578063a9059cbb146105fe578063b145a5b81461061157610382565b8063923c1d61146105cb57806395d89b41146105d35780639a6fd6fc146105db57610382565b806386824aca116101b857806386824aca1461059557806386c52694146105a85780638757b15b146105bb5780638da5cb5b146105c357610382565b80637acb77571461055a5780637f7af7781461056d57806381974e901461058257610382565b806339509351116102b85780636a4874a1116102565780636e553f65116102305780636e553f651461052457806370a0823114610537578063715018a61461054a578063742c20851461055257610382565b80636a4874a1146105015780636b091695146105095780636e1933c31461051c57610382565b806344214ecf1161029257806344214ecf146104cb5780634b0ee02a146104d35780634b820093146104e65780634f39059c146104f957610382565b806339509351146104925780633969dfb4146104a55780633dfd3873146104b857610382565b806318160ddd116103255780632495a599116102ff5780632495a5991461045a5780632cdacb50146104625780632e1a7d4d1461046a578063313ce5671461047d57610382565b806318160ddd1461041f5780631f52f2d11461043457806323b872dd1461044757610382565b806306fdde031161036157806306fdde03146103da578063095ea7b3146103ef5780630bece79c1461040257806314d6aed01461041757610382565b80628cc2621461038757806301e462dd146103b057806305fcaff1146103c5575b600080fd5b61039a610395366004613de7565b6106f9565b6040516103a79190614289565b60405180910390f35b6103c36103be366004613e1f565b610778565b005b6103cd6107a3565b6040516103a791906142e1565b6103e26107ac565b6040516103a79190614301565b6103cd6103fd366004613f21565b610842565b61040a610860565b6040516103a791906141da565b6103c361086f565b610427611028565b6040516103a791906147f9565b6103c3610442366004613de7565b61102e565b6103cd610455366004613ee1565b611057565b61040a6110df565b61040a6110ee565b6103c3610478366004614098565b611106565b6104856111da565b6040516103a7919061482a565b6103cd6104a0366004613f21565b6111df565b6103c36104b3366004614098565b61122d565b6103c36104c6366004613de7565b611236565b61040a6112bf565b6104276104e1366004613de7565b6112ce565b6103cd6104f4366004613de7565b6112d9565b61040a61130a565b61040a611319565b6103c3610517366004613e1f565b611331565b6103e2611380565b6103c36105323660046140c8565b6113b9565b610427610545366004613de7565b6113c3565b6103c36113de565b6103c3611440565b6103c36105683660046140c8565b61166e565b610575611775565b6040516103a791906142ec565b6103c3610590366004614098565b611799565b6103cd6105a3366004613de7565b611aa6565b6103c36105b6366004613de7565b611abb565b6103c3611d45565b61040a611ddd565b61040a611dec565b6103e2611e04565b6103e2611e65565b6103cd6105f1366004613f21565b611e9a565b61040a611f02565b6103cd61060c366004613f21565b611f26565b6103cd611f3a565b61039a610627366004613de7565b611f4a565b610427611f55565b6103cd611f5b565b6103c361064a366004613de7565b611f6b565b61040a611f90565b6103e2611f9f565b61042761066d366004613e1f565b611fd1565b610427611ffc565b61040a612002565b6103c3610690366004613de7565b612011565b6106a86106a3366004614098565b6120ab565b6040516103a7949392919061422c565b6103c36106c6366004613de7565b6120ee565b6103c36121c6565b6103c36106e1366004614098565b61222e565b6104276106f4366004613de7565b6124ea565b600954604051637050ccd960e01b81526060916001600160a01b031690637050ccd99061072d903090600190600401614255565b600060405180830381600087803b15801561074757600080fd5b505af115801561075b573d6000803e3d6000fd5b505050506107676125db565b61077082612656565b90505b919050565b604080518082019091526001600160a01b0380841682528216602082015261079f90612b2a565b5050565b60135460ff1681565b60108054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156108385780601f1061080d57610100808354040283529160200191610838565b820191906000526020600020905b81548152906001019060200180831161081b57829003601f168201915b5050505050905090565b600061085661084f612c77565b8484612c7b565b5060015b92915050565b600b546001600160a01b031681565b600954600c546001600160a01b0390911690610c6757600c604051806080016040528073d533a949740bb3306d119cc777fa900ba034cd526001600160a01b03168152602001836001600160a01b03168152602001600081526020016000815250908060018154018082558091505060019003906000526020600020906006020160009091909190915060008201518160000160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555060208201518160010160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555060408201518160020155606082015181600301555050600c6040518060800160405280734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b6001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815250908060018154018082558091505060019003906000526020600020906006020160009091909190915060008201518160000160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555060208201518160010160006101000a8154816001600160a01b0302191690836001600160a01b03160217905550604082015181600201556060820151816003015550506000600101600d600073d533a949740bb3306d119cc777fa900ba034cd526001600160a01b03166001600160a01b031681526020019081526020016000208190555060018001600d6000734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b6001600160a01b03166001600160a01b031681526020019081526020016000208190555073d533a949740bb3306d119cc777fa900ba034cd526001600160a01b031663a9059cbb3060006040518363ffffffff1660e01b8152600401610b14929190614270565b602060405180830381600087803b158015610b2e57600080fd5b505af1158015610b42573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b669190613f4c565b5060405163a9059cbb60e01b8152734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b9063a9059cbb90610ba1903090600090600401614270565b602060405180830381600087803b158015610bbb57600080fd5b505af1158015610bcf573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bf39190613f4c565b506000805160206148c383398151915273d533a949740bb3306d119cc777fa900ba034cd52604051610c2591906141da565b60405180910390a16000805160206148c3833981519152734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b604051610c5e91906141da565b60405180910390a15b6000816001600160a01b031663d55a23f46040518163ffffffff1660e01b815260040160206040518083038186803b158015610ca257600080fd5b505afa158015610cb6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cda91906140b0565b905060005b8181101561102357604051632061aa2360e11b81526000906001600160a01b038516906340c3544690610d169085906004016147f9565b60206040518083038186803b158015610d2e57600080fd5b505afa158015610d42573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d669190613e03565b90506000816001600160a01b031663f7c618c16040518163ffffffff1660e01b815260040160206040518083038186803b158015610da357600080fd5b505afa158015610db7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ddb9190613e03565b90506097600a5410610e5b57806001600160a01b031663fc0c546a6040518163ffffffff1660e01b815260040160206040518083038186803b158015610e2057600080fd5b505afa158015610e34573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e589190613e03565b90505b6001600160a01b038116734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b1415610ec95781600c600181548110610e8f57fe5b906000526020600020906006020160010160006101000a8154816001600160a01b0302191690836001600160a01b03160217905550611019565b6001600160a01b0381166000908152600d602052604090205461101957604080516080810182526001600160a01b038084168083528582166020808501918252600085870181815260608701828152600c8054600181018255818552985160069099027fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c7810180549a8a166001600160a01b03199b8c1617905595517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c88701805491909916991698909817909655517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c984015593517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8ca909201919091559254908252600d90925282902055516000805160206148c3833981519152906110109083906141da565b60405180910390a15b5050600101610cdf565b505050565b60025490565b604080518082019091526001600160a01b03821681526000602082015261105490612b2a565b50565b6000611064848484612d2f565b6110d484611070612c77565b6110cf85604051806060016040528060288152602001614909602891396001600160a01b038a166000908152600160205260408120906110ae612c77565b6001600160a01b031681526020810191909152604001600020549190612e44565b612c7b565b5060015b9392505050565b6007546001600160a01b031690565b73f403c135812408bfbe8713b5a23a04b3d48aae3181565b8015611193576111163382612e70565b600954604051631c683a1b60e11b81526001600160a01b03909116906338d0743690611149908490600090600401614802565b600060405180830381600087803b15801561116357600080fd5b505af1158015611177573d6000803e3d6000fd5b505060085461119392506001600160a01b031690503383612f46565b336001600160a01b03167f2fd83d5e9f5d240bed47a97a24cf354e4047e25edc2da27b01fd95e5e8a0c9a58260006040516111cf929190614802565b60405180910390a250565b601290565b60006108566111ec612c77565b846110cf85600160006111fd612c77565b6001600160a01b03908116825260208083019390935260409182016000908120918c168152925290205490612f9c565b61105481612fc1565b600f546001600160a01b031633146112695760405162461bcd60e51b815260040161126090614551565b60405180910390fd5b600e80546001600160a01b0319166001600160a01b0383161790556040517f4eab7b127c764308788622363ad3e9532de3dfba7845bd4f84c125a22544255a906112b49083906141da565b60405180910390a150565b600e546001600160a01b031681565b60006107708261308a565b604080518082019091526001600160a01b03821681526000602082018190529061130290612b2a565b506001919050565b6007546001600160a01b031681565b73d533a949740bb3306d119cc777fa900ba034cd5281565b336001600160a01b038316146113595760405162461bcd60e51b815260040161126090614586565b604080518082019091526001600160a01b0380841682528216602082015261079f9061329b565b6040518060400160405280601c81526020017f496e76616c696453696c6f5265706f7369746f7279416464726573730000000081525081565b61079f8282613387565b6001600160a01b031660009081526020819052604090205490565b600f546001600160a01b031633146114085760405162461bcd60e51b815260040161126090614551565b600f546040516000916001600160a01b031690600080516020614931833981519152908390a3600f80546001600160a01b0319169055565b604051630c5a30b960e11b81526000906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906318b461729061148f9030906004016141da565b602060405180830381600087803b1580156114a957600080fd5b505af11580156114bd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114e19190613e03565b90506001600160a01b03811661153857604080518082018252601981527810dbdb1b185d195c985b15985d5b1d139bdd10dc99585d1959603a1b6020820152905162461bcd60e51b81526112609190600401614301565b6001600160a01b038082166000908152601260209081526040808320805460ff1916600117905580516303e21fa960e61b8152905192937f0000000000000000000000000000000000000000000000000000000000000000169263f887ea409260048084019391929182900301818787803b1580156115b657600080fd5b505af11580156115ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115ee9190613e03565b6001600160a01b038082166000908152601260205260409020805460ff19166001179055600b549192509081169083161461079f57600b80546001600160a01b0319166001600160a01b0384169081179091556040517f98591b379d0945355df2687e7941177774bf190304dba561b029c0f63fcbc17990600090a25050565b600e54600160a01b900460ff16156116985760405162461bcd60e51b81526004016112609061462b565b8115611723576116a881836134b1565b6008546116c0906001600160a01b0316333085613565565b60095460405163534a7e1d60e11b81526001600160a01b039091169063a694fc3a906116f09085906004016147f9565b600060405180830381600087803b15801561170a57600080fd5b505af115801561171e573d6000803e3d6000fd5b505050505b806001600160a01b0316336001600160a01b03167fb32af138549e2a71563d1f2b1f7f0a139b3cdbc83d877d13603de1c3c5fd487a846000604051611769929190614802565b60405180910390a35050565b7fe99ed41de618732efbc0d0095584567f6718769787fe3fbb41fd1632fd5481c281565b60135460ff16156117e857604080518082018252601681527514da5b1bd5dc985c1c195c905b1c9958591e525b9a5d60521b6020820152905162461bcd60e51b81526112609190600401614301565b6013805460ff19166001179055600e54600160a81b900460ff1661185c5760405163fe4b84df60e01b8152309063fe4b84df906118299084906004016147f9565b600060405180830381600087803b15801561184357600080fd5b505af1158015611857573d6000803e3d6000fd5b505050505b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316638da5cb5b6040518163ffffffff1660e01b8152600401602060405180830381600087803b1580156118b757600080fd5b505af11580156118cb573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118ef9190613e03565b600f80546001600160a01b0319166001600160a01b039283161790819055604051911690309060008051602061493183398151915290600090a3600860009054906101000a90046001600160a01b03166001600160a01b03166306fdde036040518163ffffffff1660e01b815260040160006040518083038186803b15801561197757600080fd5b505afa15801561198b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526119b39190810190613f94565b6040516020016119c39190614137565b604051602081830303815290604052601090805190602001906119e7929190613cce565b50600860009054906101000a90046001600160a01b03166001600160a01b03166395d89b416040518163ffffffff1660e01b815260040160006040518083038186803b158015611a3657600080fd5b505afa158015611a4a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611a729190810190613f94565b604051602001611a8291906141a0565b6040516020818303038152906040526011908051906020019061079f929190613cce565b60126020526000908152604090205460ff1681565b600f546001600160a01b03163314611ae55760405162461bcd60e51b815260040161126090614551565b6001600160a01b0381166000908152600d6020526040902054611cae57604080516080810182526001600160a01b038084168083526000602080850182815285870183815260608701848152600c8054600181018255818752985160069099027fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c7810180549a8a166001600160a01b03199b8c1617905593517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c88501805491909916991698909817909655517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8c982015593517fdf6966c971051c3d54ec59162606531493a51404a002842f56009d7e5cf4a8ca909401939093559254818452600d90925283832091909155915163a9059cbb60e01b815263a9059cbb91611c3191309190600401614270565b602060405180830381600087803b158015611c4b57600080fd5b505af1158015611c5f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c839190613f4c565b506000805160206148c383398151915281604051611ca191906141da565b60405180910390a1611054565b6001600160a01b0381166000908152600d6020526040902054801561079f576000600c6001830381548110611cdf57fe5b6000918252602090912060069091020180549091506001600160a01b03166110235780546001600160a01b0319166001600160a01b0384161781556040516000805160206148c383398151915290611d389085906141da565b60405180910390a1505050565b600754611d71906001600160a01b031673f403c135812408bfbe8713b5a23a04b3d48aae316000613586565b600754611d9e906001600160a01b031673f403c135812408bfbe8713b5a23a04b3d48aae31600019613586565b600954600854611dbc916001600160a01b0391821691166000613586565b600954600854611ddb916001600160a01b039182169116600019613586565b565b600f546001600160a01b031681565b734e3fbd56cd56c3e72c1403e103b45db9da5b9d2b81565b60118054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156108385780601f1061080d57610100808354040283529160200191610838565b6040518060400160405280601981526020017810dbdb1b185d195c985b15985d5b1d139bdd10dc99585d1959603a1b81525081565b6000610856611ea7612c77565b846110cf856040518060600160405280602581526020016149516025913960016000611ed1612c77565b6001600160a01b03908116825260208083019390935260409182016000908120918d16815292529020549190612e44565b7f000000000000000000000000000000000000000000000000000000000000000081565b6000610856611f33612c77565b8484612d2f565b600e54600160a81b900460ff1681565b606061077082612656565b600c5490565b600e54600160a01b900460ff1681565b604080518082019091526001600160a01b03821680825260208201526110549061329b565b6009546001600160a01b031681565b6040518060400160405280601681526020017514da5b1bd5dc985c1c195c905b1c9958591e525b9a5d60521b81525081565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b600a5481565b6008546001600160a01b031681565b600f546001600160a01b0316331461203b5760405162461bcd60e51b815260040161126090614551565b6001600160a01b0381166120615760405162461bcd60e51b815260040161126090614377565b600f546040516001600160a01b0380841692169060008051602061493183398151915290600090a3600f80546001600160a01b0319166001600160a01b0392909216919091179055565b600c81815481106120b857fe5b600091825260209091206006909102018054600182015460028301546003909301546001600160a01b0392831694509116919084565b600f546001600160a01b031633146121185760405162461bcd60e51b815260040161126090614551565b6001600160a01b0381166000908152600d6020526040902054801561079f576000600c600183038154811061214957fe5b6000918252602090912060069091020180549091506001600160a01b038481169116146121885760405162461bcd60e51b8152600401611260906146c8565b80546001600160a01b03191681556040517f646cfe9445aed85f4853d501d1924d2bdabb1bbf12531df29f929f07ba4169e090611d389085906141da565b600f546001600160a01b031633146121f05760405162461bcd60e51b815260040161126090614551565b600e805460ff60a01b1916600160a01b1790556040517f4426aa1fb73e391071491fcfe21a88b5c38a0a0333a1f6e77161470439704cf890600090a1565b600e54600160a81b900460ff16156122585760405162461bcd60e51b8152600401611260906144ea565b600f80546001600160a01b0319163317908190556040516001600160a01b039190911690600090600080516020614931833981519152908290a3604051631526fe2760e01b81526000908190819073f403c135812408bfbe8713b5a23a04b3d48aae3190631526fe27906122d09087906004016147f9565b60c06040518083038186803b1580156122e857600080fd5b505afa1580156122fc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123209190613e57565b5050600780546001600160a01b038087166001600160a01b0319928316179092556008805483871690831681179091556009805493851693909216929092179055600a899055604080516306fdde0360e01b81529051959850939650909450926306fdde03926004808201935060009291829003018186803b1580156123a557600080fd5b505afa1580156123b9573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526123e19190810190613f94565b6040516020016123f19190614108565b60405160208183030381529060405260109080519060200190612415929190613cce565b50816001600160a01b03166395d89b416040518163ffffffff1660e01b815260040160006040518083038186803b15801561244f57600080fd5b505afa158015612463573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261248b9190810190613f94565b60405160200161249b9190614175565b604051602081830303815290604052601190805190602001906124bf929190613cce565b50600e805461ffff60a01b1916600160a81b1790556124dc61086f565b6124e4611d45565b50505050565b600d6020526000908152604090205481565b60408051600481526024810182526020810180516001600160e01b03166001600160e01b03198516179052905160009182916060916001600160a01b0387169161254691906140ec565b600060405180830381855afa9150503d8060008114612581576040519150601f19603f3d011682016040523d82523d6000602084013e612586565b606091505b509150915081158061259a57508051602014155b156125aa5760009250505061085a565b6000818060200190518101906125c09190613f6c565b6001600160e01b031990811690861614935050505092915050565b600e546001600160a01b031615611ddb57600e60009054906101000a90046001600160a01b03166001600160a01b0316632663fcfc6040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561263c57600080fd5b505af192505050801561264d575060015b611ddb57611ddb565b60606000612662613649565b600c549091508067ffffffffffffffff8111801561267f57600080fd5b506040519080825280602002602001820160405280156126b957816020015b6126a6613d4c565b81526020019060019003908161269e5790505b50925060005b81811015612b22576000600c82815481106126d657fe5b6000918252602090912060069091020180549091506001600160a01b03166126fe5750612b1a565b80546040516370a0823160e01b81526000916001600160a01b0316906370a082319061272e9030906004016141da565b60206040518083038186803b15801561274657600080fd5b505afa15801561275a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061277e91906140b0565b9050600061279983600301548361365890919063ffffffff16565b60018401549091506001600160a01b03161561283b5760018301546040516246613160e11b8152612838916001600160a01b031690628cc262906127e19030906004016141da565b60206040518083038186803b1580156127f957600080fd5b505afa15801561280d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061283191906140b0565b8290612f9c565b90505b60028301548615612865576128638761285d8468056bc75e2d63100000613680565b906136ba565b015b6001600160a01b03891660009081526004850160205260408120546128ad9068056bc75e2d631000009061285d9061289e908690613658565b6128a78e61308a565b90613680565b6001600160a01b038b1660009081526005870160205260409020549091506128ff906128d99083612f9c565b8a88815181106128e557fe5b602002602001015160200151612f9c90919063ffffffff16565b89878151811061290b57fe5b6020908102919091018101510152845489516001600160a01b03909116908a908890811061293557fe5b60209081029190910101516001600160a01b03909116905285612b14576002850154915087156129f95760018501546040516246613160e11b81526129f4918a9161285d9168056bc75e2d63100000916001600160a01b0390911690628cc262906129a49030906004016141da565b60206040518083038186803b1580156129bc57600080fd5b505afa1580156129d0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128a791906140b0565b820191505b6001600160a01b038a166000908152600486016020526040902054612a329068056bc75e2d631000009061285d9061289e908690613658565b604051638487474560e01b815290915073__$bc773559428fe6419d41a765665bfcab46$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";

type ConvexSiloWrapperConstructorParams =
  | [linkLibraryAddresses: ConvexSiloWrapperLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ConvexSiloWrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class ConvexSiloWrapper__factory extends ContractFactory {
  constructor(...args: ConvexSiloWrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        ConvexSiloWrapper__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
    this.contractName = "ConvexSiloWrapper";
  }

  static linkBytecode(
    linkLibraryAddresses: ConvexSiloWrapperLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$bc773559428fe6419d41a765665bfcab46\\$__", "g"),
      linkLibraryAddresses[
        "contracts/external/convex/lib/CvxMining.sol:CvxMining"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _siloRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ConvexSiloWrapper> {
    return super.deploy(
      _siloRepository,
      overrides || {}
    ) as Promise<ConvexSiloWrapper>;
  }
  getDeployTransaction(
    _siloRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_siloRepository, overrides || {});
  }
  attach(address: string): ConvexSiloWrapper {
    return super.attach(address) as ConvexSiloWrapper;
  }
  connect(signer: Signer): ConvexSiloWrapper__factory {
    return super.connect(signer) as ConvexSiloWrapper__factory;
  }
  static readonly contractName: "ConvexSiloWrapper";
  public readonly contractName: "ConvexSiloWrapper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ConvexSiloWrapperInterface {
    return new utils.Interface(_abi) as ConvexSiloWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ConvexSiloWrapper {
    return new Contract(address, _abi, signerOrProvider) as ConvexSiloWrapper;
  }
}

export interface ConvexSiloWrapperLibraryAddresses {
  ["contracts/external/convex/lib/CvxMining.sol:CvxMining"]: string;
}
